import { ComponentProps } from 'react';
import SvgIcon from '@mui/material/SvgIcon';

type MuiIconProps = ComponentProps<typeof SvgIcon>;

export const DoneIcon = (props: MuiIconProps) => {
  return (
    <SvgIcon {...props}>
      <path d="M13.2932 3.2931C13.6838 2.90265 14.3168 2.9026 14.7073 3.2931C15.0976 3.68361 15.0977 4.31668 14.7073 4.70716L6.20728 13.2072C5.84122 13.5732 5.26217 13.5957 4.86939 13.2755L4.79322 13.2072L1.29322 9.70716L1.22486 9.63099C0.904513 9.23821 0.927107 8.65921 1.29322 8.2931C1.65934 7.92706 2.23837 7.90441 2.63111 8.22474L2.70729 8.2931L5.50025 11.0861L13.2932 3.2931Z" />
    </SvgIcon>
  );
};
